import ApplicationController from "../../../javascript/controllers/application_controller";

export default class extends ApplicationController {
  static targets = [ 
    "accordion", 
    "toggleBtn" 
  ]
  static values = { 
    isOpen: Boolean,
    reflexMethod: String,
    additionalPx: Number,
    useLocalStorage: Boolean,
    animateHeight: Boolean
  }  
  
  initialize() {
    const localStorageValue = localStorage.getItem(this.element.id);
    
    if (this.isOpenValue && localStorageValue == undefined) this.setAccordionHeight();
    
    if (this.useLocalStorageValue && localStorageValue) {
      this.isOpenValue = localStorageValue
      if (localStorageValue == "true") {
        return this.openAccordion();
      }
      this.closeAccordion();
    }
  }

  toggleOpen() {
    this.isOpenValue = !this.isOpenValue;

    if (!this.isOpenValue) {
      this.closeAccordion();
    } else {
      this.openAccordion();
    }
    
    if (this.hasReflexMethodValue) this.stimulate(`${this.reflexMethodValue}`, this.isOpenValue);
    this.updateAccessibility();
    if (this.useLocalStorageValue) localStorage.setItem(this.element.id, this.isOpenValue);
  }
  
  openAccordion() {
    this.element.classList.add("is-open");
    this.setAccordionHeight();
  }

  closeAccordion() {
    this.accordionTarget.style.maxHeight = null;
    setTimeout(() => {
      this.element.classList.remove("is-open");
    }, this.animateHeightValue ? 250 : 0)
  }

  setAccordionHeight() {
    setAccordionHeight(this.accordionTarget, this.additionalPxValue, this.animateHeightValue);
  }

  updateAccessibility() {
    this.toggleBtnTarget.setAttribute("aria-expanded", this.isOpenValue);
    this.accordionTarget.setAttribute("aria-hidden", !this.isOpenValue);
  }
}

export const setAccordionHeight = (accordion, pxValue = 3, animateHeight = true) => {
  if (!animateHeight) return;
  accordion.style.maxHeight = `${accordion.scrollHeight + pxValue}px`;
}
